'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var styles = require('./Checkbox.scss');
      var _props = this.props,
          textBefore = _props.textBefore,
          textAfter = _props.textAfter,
          className = _props.className,
          children = _props.children,
          radio = _props.radio,
          small = _props.small,
          thin = _props.thin,
          formProps = (0, _objectWithoutProperties3.default)(_props, ['textBefore', 'textAfter', 'className', 'children', 'radio', 'small', 'thin']);


      return _react2.default.createElement(
        'label',
        { className: (0, _classnames2.default)(styles.checkbox, className, { radio: radio }) },
        children,
        _react2.default.createElement('input', (0, _extends3.default)({ type: radio ? 'radio' : 'checkbox' }, formProps)),
        textBefore && _react2.default.createElement(
          'span',
          { className: styles.textBefore },
          textBefore
        ),
        _react2.default.createElement('i', { className: (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.small, small), (0, _defineProperty3.default)(_classNames, styles.thin, thin), _classNames)) }),
        textAfter && _react2.default.createElement(
          'span',
          { className: styles.textAfter },
          textAfter
        )
      );
    }
  }]);
  return Checkbox;
}(_react.Component), _class.propTypes = {
  checked: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  defaultChecked: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  radio: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  textAfter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  textBefore: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  thin: _propTypes2.default.bool
}, _class.defaultProps = {
  name: 'checkbox',
  textBefore: '',
  textAfter: '',
  checked: false,
  onChange: function onChange() {}
}, _temp);
exports.default = Checkbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.js
// module id = 180
// module chunks = 1